import { CartLineUpdateInput } from '@/types/storefront';
import { useCartStore } from 'stores/useCartStore';

export default function useCartUpdate(lineId: string) {
  const updateCart = async (quantity: number) => {
    try {
      const line: CartLineUpdateInput = {
        id: lineId,
        quantity: quantity
      };
      const response = await fetch('/api/cart/update', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          lines: [line]
        })
      });
      const data = await response.json();
      useCartStore.setState({ cart: data.cart });
    } catch (err) {
      console.error(err);
    }
  };
  return updateCart;
}
